export default __webpack_public_path__ + "27dc77093291ef21abf7759a6219545e.jpg";